import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCog, faPen, faSort, faTrashUndoAlt, faWarning,
} from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Heading, IconWithMenu, Link, SortableList,
} from '@domain-group/suit-theme'

import { confirmAction } from '@functions/entity'

import useCampaignQuoteTemplateSections from '@hooks/useCampaignQuoteTemplateSections'

import NoticeBox from '@components/NoticeBox'

import useQuoteTemplateBuilder from '../../hooks/useQuoteTemplateBuilder'

import CampaignQuoteTemplateSection from '../CampaignQuoteTemplateSection'

interface QuoteProps {
  quoteTemplateBuilderPayload: ReturnType<typeof useQuoteTemplateBuilder>,
}

const CampaignQuoteTemplate = (props: QuoteProps) => {
  const {
    quoteTemplateBuilderPayload: {
      callbacks: {
        modifySectionItemSort,
      },
      campaignQuoteTemplatePayload: {
        callbacks: {
          createOrEditCampaignQuoteTemplate,
          editSectionSort,
          toggleHideCampaignQuoteTemplate,
        },
        campaignQuoteTemplate: {
          hidden,
          id,
          title,
        },
        updating,
      },
      sortedSectionItemIds,
    },
  } = props

  const campaignQuoteTemplateSectionsPayload = useCampaignQuoteTemplateSections({
    filters: {
      campaign_quote_template_id: id,
    },
    performHttpRequests: false,
  })

  const {
    filteredCampaignQuoteTemplateSections,
    filteredCampaignQuoteTemplateSectionIds,
    lastSectionIndex,
  } = campaignQuoteTemplateSectionsPayload

  const toggleHiddenPayload = {
    callbacks: {
      actionFn: toggleHideCampaignQuoteTemplate,
    },
    options: {
      icon: 'warning',
    },
    strings: {
      actionString: 'unarchive',
      entityName: 'quote template',
    },
  }

  return (
    <>
      {hidden && (
        <NoticeBox
          actionContent={(
            <Button
              buttonStyle="secondaryUtility"
              height="fit-content"
              icon={<FontAwesomeIcon icon={faTrashUndoAlt} />}
              loading={updating}
              // @ts-expect-error TS2345
              onClick={() => confirmAction(toggleHiddenPayload)}
              size="medium"
              width={['100%', 'fit-content']}
            >
              Unarchive Template
            </Button>
          )}
          icon={<FontAwesomeIcon icon={faWarning} />}
        >
          <NoticeBox.Title>Quote Template is Archived</NoticeBox.Title>

          <NoticeBox.Paragraph>Template is archived and cannot be used for quotes.</NoticeBox.Paragraph>
        </NoticeBox>
      )}

      <Box flexDirection="column" marginBottom="large" variant="white">
        <Box
          alignItems={['flex-start', 'center']}
          borderBottom="1px solid"
          borderColor="lineColor"
          flexDirection={['column', 'row']}
          padding="large"
        >
          <Heading size="large" textProps={{ lineHeight: '1.3' }}>
            {title || 'Loading...'}
          </Heading>

          <Box
            borderTop={['1px dashed', 'none']}
            borderColor="lineColor"
            justifyContent="flex-end"
            marginTop={['large', 0]}
            paddingTop={['large', 0]}
            marginLeft="auto"
            width={['100%', 'auto']}
          >
            <IconWithMenu
              boxProps={{ position: 'relative' }}
              icon={<Button buttonStyle="secondaryUtility" icon={<FontAwesomeIcon icon={faCog} />} size="large" />}
            >
              {/*
               // @ts-expect-error TS2741 */}
              <IconWithMenu.Menu closeOnClick listStyle={{ right: 0 }}>
                <Link key="edit" onClick={() => createOrEditCampaignQuoteTemplate()} target="blank">
                  <FontAwesomeIcon icon={faPen} /> Edit Template Details
                </Link>

                <Link key="sort" onClick={() => editSectionSort()} target="blank">
                  <FontAwesomeIcon icon={faSort} /> Sort Sections
                </Link>
              </IconWithMenu.Menu>
            </IconWithMenu>
          </Box>
        </Box>

        <SortableList
          callbacks={{
            onDragEnd: (fromIndex, toIndex, dragDropPayload) => modifySectionItemSort({
              // @ts-expect-error TS2322
              dragDropPayload,
              fromIndex,
              // @ts-expect-error TS2322
              toIndex,
            }),
          }}
        >
          {/*
           // @ts-expect-error TS2739 */}
          {filteredCampaignQuoteTemplateSections.map((campaignQuoteTemplateSection, index) => {
            const { id } = campaignQuoteTemplateSection
            // @ts-expect-error TS7053
            const sortedItemIds = sortedSectionItemIds[`Section-${id}`] || []

            return (
              <CampaignQuoteTemplateSection
                // @ts-expect-error TS2739
                callbacks={{}}
                campaignQuoteTemplateSection={campaignQuoteTemplateSection}
                campaignQuoteTemplateSectionIds={filteredCampaignQuoteTemplateSectionIds}
                first={index === 0}
                index={index}
                key={campaignQuoteTemplateSection.id}
                last={lastSectionIndex === index}
                lastIndex={lastSectionIndex}
                sortedCampaignQuoteTemplateItemIds={sortedItemIds}
              />
            )
          })}
        </SortableList>
      </Box>
    </>
  )
}

export default CampaignQuoteTemplate
